import React, { useState } from "react"
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import EditIcon from "@mui/icons-material/Edit"
import LinkOffIcon from "@mui/icons-material/LinkOff"

const sx = {
  card: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    gap: "12px 16px",
    alignItems: "flex-start",
    p: 2,
    border: "1px solid #DCDCDC",
    borderRadius: 2,
    bgcolor: "background.paper",
    mb: 2,
    "&:last-child": { mb: 0 },
  },
  body: {
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: 3,
  },
  head: {
    display: "flex",
    alignItems: "center",
    gap: 1.25,
    flexWrap: "wrap",
  },
  name: {
    fontSize: 16,
    fontWeight: 500,
    color: "text.primary",
  },
  code: {
    fontSize: 12,
    color: "text.secondary",
    bgcolor: "grey.100",
    px: 1,
    py: 0.5,
    borderRadius: 0.5,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "12px 24px",
  },
  kv: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    minWidth: 0,
  },
  kvLabel: {
    fontSize: 12,
    color: "text.secondary",
    letterSpacing: "0.02em",
    fontWeight: 500,
  },
  kvValue: {
    fontSize: 14,
    color: "text.primary",
    lineHeight: 1.4,
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
  kvEmpty: {
    fontSize: 14,
    color: "text.disabled",
    fontStyle: "italic",
  },
  kvVolume: {
    fontSize: 14,
    color: "text.primary",
    fontWeight: 500,
  },
  menuPaper: {
    minWidth: 160,
    border: "1px solid",
    borderColor: "divider",
    borderRadius: 1,
    boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
    overflow: "hidden",
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 2,
    py: 2,
    fontSize: 14,
    color: "text.primary",
  },
  menuIcon: {
    fontSize: "18px !important",
    color: "text.secondary",
  },
}

const DCCard = ({ link, onEdit, onDetach }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const menuOpen = Boolean(anchorEl)

  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget)
  const handleMenuClose = () => setAnchorEl(null)

  const handleEdit = () => {
    handleMenuClose()
    onEdit(link)
  }

  const handleDetach = () => {
    handleMenuClose()
    onDetach(link)
  }

  const vol = link.minimumDeliveryVolume > 0 ? `${link.minimumDeliveryVolume} plats` : null

  return (
    <Box sx={sx.card}>
      <Box sx={sx.body}>
        <Box sx={sx.head}>
          <Typography sx={sx.name}>{link.dcName}</Typography>
          {link.dcCode && <Typography component="span" sx={sx.code}>{link.dcCode}</Typography>}
        </Box>

        <Box sx={sx.grid}>
          <Box sx={sx.kv}>
            <Typography sx={sx.kvLabel}>Créneaux de livraison</Typography>
            {link.deliveryScheduleNotes
              ? <Typography sx={sx.kvValue}>{link.deliveryScheduleNotes}</Typography>
              : <Typography sx={sx.kvEmpty}>—</Typography>
            }
          </Box>
          <Box sx={sx.kv}>
            <Typography sx={sx.kvLabel}>Notes packaging</Typography>
            {link.packagingNotes
              ? <Typography sx={sx.kvValue}>{link.packagingNotes}</Typography>
              : <Typography sx={sx.kvEmpty}>—</Typography>
            }
          </Box>
          <Box sx={sx.kv}>
            <Typography sx={sx.kvLabel}>Volume min. / livraison</Typography>
            {vol
              ? <Typography sx={sx.kvVolume}>{vol}</Typography>
              : <Typography sx={sx.kvEmpty}>—</Typography>
            }
          </Box>
        </Box>
      </Box>

      <Box>
        <IconButton size="small" onClick={handleMenuOpen}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
          PaperProps={{ sx: sx.menuPaper }}
        >
          <MenuItem onClick={handleEdit} sx={sx.menuItem}>
            <EditIcon sx={sx.menuIcon} />
            Modifier
          </MenuItem>
          <MenuItem onClick={handleDetach} sx={{ ...sx.menuItem, color: "error.main" }}>
            <LinkOffIcon sx={{ ...sx.menuIcon, color: "error.main" }} />
            Désactiver
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  )
}

export default DCCard
